import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  loading: true,
  plainData: new Map(),
  groupedData: {},
  totalsByDate: {},
  totalsByDriver: {},
  totalsByNoOwner: 0,
  costByDate: {},
  nextLink: '',
  mounted: false,
  loadingNextPage: false,
  journeysSummaryModal: {
    open: false,
    props: {},
  },
  reviewStatus: {},
};

// Actions
const SET_LOADING = 'journeys/SET_LOADING';
const SET_ERROR = 'journeys/SET_ERROR';
const SET_NEXT_LINK = 'journeys/SET_NEXT_LINK';

const SET_PLAIN_DATA = 'journeys/SET_PLAIN_DATA';
const RESET_PLAIN_DATA = 'journeys/RESET_PLAIN_DATA';
const SET_GROUPED_DATA = 'journeys/SET_GROUPED_DATA';
const SET_PLAIN_AND_GROUPED_DATA = 'journeys/SET_PLAIN_AND_GROUPED_DATA';
const SET_PATCH_DATA = 'journeys/SET_PATCH_DATA';

const SET_TOTALS_BY_DATE = 'journeys/SET_TOTALS_BY_DATE';
const SET_TOTALS_BY_NO_OWNER = 'journeys/SET_TOTALS_BY_NO_OWNER';
const SET_TOTALS_BY_DRIVER = 'journeys/SET_TOTALS_BY_DRIVER';
const SET_COST_BY_DATE = 'journeys/SET_COST_BY_DATE';

const SET_JOBS_SUMMARY_MODAL_OPEN = 'journeys/SET_JOBS_SUMMARY_MODAL_OPEN';
const SET_JOBS_SUMMARY_MODAL_CLOSED = 'journeys/SET_JOBS_SUMMARY_MODAL_CLOSED';

const SET_MOUNTED = 'journeys/SET_MOUNTED';

const SET_LOADING_NEXT_PAGE = 'journeys/SET_LOADING_NEXT_PAGE';

const SET_REVIEWING_JOURNEY = 'journeys/SET_REVIEWING_JOURNEY';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_LOADING](state, action) {
    return {
      ...state,
      loading: action,
    };
  },
  [SET_ERROR](state, error) {
    return {
      ...state,
      error: error,
    };
  },
  [SET_MOUNTED](state, mounted) {
    return {
      ...state,
      mounted,
    };
  },
  [SET_PLAIN_DATA](state, { plainData }) {
    return {
      ...state,
      plainData,
    };
  },
  [SET_PATCH_DATA](state, journey) {
    const plainData = state.plainData;
    plainData.set(journey.id, { ...journey });

    return {
      ...state,
      plainData: new Map(plainData),
    };
  },
  [RESET_PLAIN_DATA](state) {
    return {
      ...state,
      plainData: new Map(),
    };
  },
  [SET_GROUPED_DATA](state, { groupedData }) {
    return {
      ...state,
      groupedData,
    };
  },
  [SET_PLAIN_AND_GROUPED_DATA](state, { plainData, groupedData }) {
    return {
      ...state,
      plainData,
      groupedData,
    };
  },
  [SET_NEXT_LINK](state, nextLink) {
    return {
      ...state,
      nextLink,
    };
  },
  [SET_TOTALS_BY_DATE](state, { totalsByDate }) {
    return {
      ...state,
      totalsByDate,
    };
  },
  [SET_TOTALS_BY_NO_OWNER](state, { totalsByNoOwner }) {
    return {
      ...state,
      totalsByNoOwner,
    };
  },
  [SET_COST_BY_DATE](state, { costByDate }) {
    return {
      ...state,
      costByDate,
    };
  },
  [SET_TOTALS_BY_DRIVER](state, { totalsByDriver }) {
    return {
      ...state,
      totalsByDriver,
    };
  },
  [SET_JOBS_SUMMARY_MODAL_OPEN](state, { date, shipperId }) {
    return {
      ...state,
      journeysSummaryModal: {
        open: true,
        props: {
          date,
          shipperId,
        },
      },
    };
  },
  [SET_JOBS_SUMMARY_MODAL_CLOSED](state) {
    return {
      ...state,
      journeysSummaryModal: {
        open: false,
        props: {},
      },
    };
  },
  [SET_LOADING_NEXT_PAGE](state, loadingNextPage) {
    return {
      ...state,
      loadingNextPage,
    };
  },
  [SET_REVIEWING_JOURNEY](state, { journeyId, reviewing, reviewed }) {
    return {
      ...state,
      reviewStatus: {
        ...state.reviewStatus,
        [journeyId]: { reviewing, reviewed },
      },
    };
  },
});

// Action creators
export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const setNextLink = (nextLink) => ({
  type: SET_NEXT_LINK,
  payload: nextLink,
});

export const setPlainData = (plainData) => ({
  type: SET_PLAIN_DATA,
  payload: { plainData },
});

export const resetPlainData = () => ({
  type: RESET_PLAIN_DATA,
  payload: {},
});

export const setGroupedData = (groupedData) => ({
  type: SET_GROUPED_DATA,
  payload: { groupedData },
});

export const setPlainAndGroupedData = ({ plainData, groupedData }) => ({
  type: SET_PLAIN_AND_GROUPED_DATA,
  payload: { plainData, groupedData },
});

export const setTotalsByDate = (totalsByDate) => ({
  type: SET_TOTALS_BY_DATE,
  payload: { totalsByDate },
});

export const setTotalsByNoOwner = (totalsByNoOwner) => ({
  type: SET_TOTALS_BY_NO_OWNER,
  payload: { totalsByNoOwner },
});

export const setTotalsByDriver = (totalsByDriver) => ({
  type: SET_TOTALS_BY_DRIVER,
  payload: { totalsByDriver },
});

export const setCostByDate = (costByDate) => ({
  type: SET_COST_BY_DATE,
  payload: { costByDate },
});

export const setPatchData = (journey) => ({
  type: SET_PATCH_DATA,
  payload: journey,
});

export const setMounted = (mounted) => ({
  type: SET_MOUNTED,
  payload: mounted,
});

export const setJobsSummaryModalOpen = ({ shipperId, date }) => ({
  type: SET_JOBS_SUMMARY_MODAL_OPEN,
  payload: {
    shipperId,
    date,
  },
});

export const setJobsSummaryModalClosed = () => ({
  type: SET_JOBS_SUMMARY_MODAL_CLOSED,
});

export const setLoadingNextPage = (loadingNextPage) => ({
  type: SET_LOADING_NEXT_PAGE,
  payload: loadingNextPage,
});

export const setReviewingJourney = ({ journeyId, reviewing, reviewed }) => ({
  type: SET_REVIEWING_JOURNEY,
  payload: {
    journeyId,
    reviewing,
    reviewed,
  },
});
